module.exports = __webpack_public_path__ + "static/media/arrow-ios-down.6cc433d0.svg";